<script>
  export let progress = 20;
  console.log(progress);
</script>

<style>
  .progress-container {
    margin: 20px 0;
    border: 1px solid rgb(194, 194, 194);
  }
  .progress-bar {
    height: 20px;
    background-color: rgb(77, 199, 55);
  }
</style>

<div bp="grid">
  <div bp="offset-5@md 4@md 12@sm" class="progress-container">
    <div class="progress-bar" style="width:{progress}%">
      <span class="sr-only">{progress}%</span>
    </div>
  </div>
</div>
